import React, { useContext, useState, useEffect } from "react";
import { UserContext } from '../../context/User';
import { useHistory } from "react-router-dom";
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { somethingWentWrongNotice } from '../UI/Notifications';
import { SearchContext } from '../../context/Search';
import SearchSettings from "../SearchSettings";
import TableContainer from "../TableContainer";
import Pagination from "../Pagination";
import PageSwitcher from "../PageSwitcher";
import Loading from '../Loading';
import { scheduleEmailsSearchPost } from '../../api';

const REPORT_SEARCH_SELECT = [
  "template_id",
  "subject",
  "body",
  "recurrence_frequency",
  "recurrence_interval",
  "scheduled_send_time",
  "template_title",
  "created",
  "is_active"
]


const ScheduleEmails = () => {
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(null);
  const [offset, setOffset] = useState(0);
  const [active, setActive] = useState("schedule_emails")
  const [limit, setLimit] = useState(10);
  const [pageCount, setPageCount] = useState(0);
  const [searchedData, setSearchedData] = useState([]);
  const [forcePage, setForcePage] = useState(0);
  const { setUser, setIsLoggedIn } = useContext(UserContext);
  const history = useHistory();
  const [sorted, setSorted] = useState(false);
  const [orderByParams, setOrderByParams] = useState([]);
  const [currentInputValues, setCurrentInputValues] = useState({
    search: ""
  });
  const [searchTrigger, setSearchTrigger] = useState(false);

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push('/');
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout()
    } else {
      somethingWentWrongNotice("Schedule Emails");
    }

    setLoading(false);
  }

  const dataStructuring = (fullTextParams) => {
    setLoading(true);

    if (!fullTextParams.search) delete fullTextParams.search;

    requestHandler(fullTextParams, {});
  }

  const onSubmit = () => {
    const fullTextParams = {
      limit: limit,
      offset: offset,
      // select: REPORT_SEARCH_SELECT,
    };

    dataStructuring(fullTextParams);
  }

  const sortHandler = (sort_by) => {
    const fullTextParams = {
      limit: limit,
      offset: offset,
      // select: REPORT_SEARCH_SELECT,
      order_by: sort_by && sort_by,
    };

    if (!fullTextParams.order_by) delete fullTextParams.order_by;

    dataStructuring(fullTextParams);
  }

  useEffect(() => {
    if (sorted) sortHandler(orderByParams);
    if (!sorted) onSubmit();
  }, [limit, offset, orderByParams, searchTrigger])

  const requestHandler = (fullTextParams, data) => {

    scheduleEmailsSearchPost(fullTextParams)
      .then(response => {
        setSearchedData(response.data.results);
        setTotalCount(response.data.total_count);
        setSorted(false);
        setLoading(false);
      })
      .catch(error => {
        error.response.status === 404 ?
          setSearchedData([]) :
          handleDefaultStatusCodes(error.response.status);
        setLoading(false);
      })
  }

  const onChangeSearchHandler = event => {
    setCurrentInputValues({
      ...currentInputValues,
      search: event.target.value
    })
  }

  return (
    <>
      <section className="section-spaces">
        <Container>
          <Row>
            <Col>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <h3 className="mb-5">
                List All Scheduled Emails
              </h3>
              <Link
                  to={`/create-email-schedule?type=email&reply=1`}
                  className="btnSizes mb-5 text-right filledBtn"
                >
                  Create Sheduled Email
              </Link>
            </div>
              {!searchedData.length && (
                <h3 className="my-5">No results</h3>
              )}
              <SearchContext.Provider value={{
                setOrderByParams,
                orderByParams,
                setSorted,
                sorted,
                setSearchedData,
                searchedData,
                totalCount,
                limit,
                offset,
                setLimit,
                setOffset,
                forcePage,
                setForcePage,
                pageCount,
                setPageCount,
                loading,
                setLoading,
                currentInputValues,
                setCurrentInputValues,
                active,
                onChangeSearchHandler,
                onSubmit,
                setSearchTrigger,
                searchTrigger
              }}
              >
                {!!searchedData && !!searchedData.length && (
                  <>
                    <SearchSettings />
                    <div className="scheduled-table-wrapper" style={{justifyContent: 'center'}}>
                      <TableContainer />
                    </div>
                    
                  </>
                )}
                {searchedData && !!searchedData.length && !!totalCount && (
                  <div className="pagination-wrap">
                    <Pagination />
                    <PageSwitcher />
                  </div>
                )}
              </SearchContext.Provider>
              {loading && <Loading />}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ScheduleEmails;